/**
 * AVANT_GARDE_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Avant-Garde / Experimental music.
 * Traits:
 * - Atonal / Highly Dissonant
 * - Irregular / Erratic Rhythm (High Entropy)
 * - Extreme Dynamic Range (Silence to ffff)
 * - Unpredictable Voice Distribution
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const AVANT_GARDE_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Erratic.
    // Can be static (drone) or hyper-fast.
    // We set a wide tolerance.
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 4.0, // Arbitrary center
        tolerance: 3.5, // Huge tolerance (0.5 - 7.5)
        weight: 0.1 // Low weight, don't penalize pacing
    },

    // Voice Distribution: Extremes.
    // Highs and Lows, empty middle.
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.40,
        mid: 0.20,
        high: 0.40,
        tolerance: 0.30,
        tuttiThreshold: 0.5,
        weight: 0.2
    },

    // Dynamic Range: Extreme Variance.
    // Shocks, stabs, and silence.
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.25, // Needs chaos
        targetVariance: 0.40,
        dynamicShape: 'chaotic' // New shape hint?
    },

    // Interval Entropy: Very High.
    // Wide leaps, angular melody.
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.20, // Mostly leaps (80%)
        weight: 0.3
    },

    // Harmonic Consonance: Dissonance is MANDATORY.
    harmonicConsonance: {
        ...SLOW_ARCHETYPE.harmonicConsonance,
        polarity: 'dissonant',
        weight: 0.4 // Critical for genre identity
    }
};
